import { initChart, formatName } from 'vlcishared';
import { TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL } from './texts';
import { DEFAULT_LANGUAGE } from '../common-language';
import { opcionesGraficosActividadComunes } from './common-actividad-administrativa';

export function echartBarTareasPorUA(datos) {
  const { opcionesGrafica } = opcionesGraficosActividadComunes(datos);
  const SIZE_VALUE = 20;
  
  opcionesGrafica.title.subtext = TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get('UA');
  opcionesGrafica.xAxis[0].axisLabel = {
    show: true,
    interval: 0,
    rotate: 55,
    padding: 0,
    margin: 10,
    fontSize: 8,
    lineHeight: 10,
    verticalAlign: 'middle',
    fontFamily: 'Montserrat',
    fontWeight: 400,
    color: '#333',
    width: 120,
    height: 20,
    overflow: 'truncate',
    ellipsis: '...',
    formatter: (value) => formatName(value, SIZE_VALUE),
  };
    opcionesGrafica.dataZoom[0].show = false;
  opcionesGrafica.media = [
    {
      query: {
        maxWidth: 430,
      },
      option: {
        title: {
          textStyle: {
            fontSize: 13,
            width: '265',
          },
          subtextStyle: {
            fontSize: 11,
            lineHeight: 11,
            width: '265',
          },
        },
      },
    },
    {
      query: {
        minWidth: 420,
      },
      option: {
        legend: {
          padding: [0, 10],
          itemWidth: 8,
          itemGap: 10,
          textStyle: {
            fontSize: '12',
          },
        },
      },
    },
    {
      query: {
        minWidth: 670,
      },
      option: {
        legend: {
          itemWidth: 20,
          itemHeight: 10,
          icon: 'roundRect',
        },
      },
    },
    {
      query: {
        minWidth: 700,
      },
      option: {
        title: {
          text: `${TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
            'tareas',
          )} ${TEXTS_ACTIVIDAD_ADMINISTRATIVA_DETAIL[DEFAULT_LANGUAGE].get(
            'UA',
          )}`,
          itemGap: 0,
          top: '10',
          subtext: '',
          textStyle: {
            fontSize: 15,
          },
        },
        toolbox: {
          top: '0',
        },
        xAxis: {
          axisLabel: {
            textStyle: {
              fontSize: 10,
            },
          },
        },
        yAxis: [
          {
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
          },
          {
            axisLabel: {
              textStyle: {
                fontSize: 10,
              },
            },
          },
        ],
      },
    },
    {
      query: {
        minWidth: 950,
      },
      option: {
        grid: {
          bottom: 20,
        },
        xAxis: {
          axisLabel: {
            rotate: 0,
            padding: 0,
            margin: 5,
            lineHeight: 12,
            verticalAlign: 'top',
            width: 100,
            height: 50,
            overflow: 'break',
          },
        },
        series: [
          {
            barMinWidth: 10,
            barMaxWidth: 16,
          },
          {
            barMinWidth: 10,
            barMaxWidth: 16,
          },
        ],
      },
    },
  ];

  initChart('chartUA', opcionesGrafica);
}
